import { hindi } from './Hindi';
import { english } from './English';

export const languageMap = {
  hindi,
  english
};